import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline caching and faster repeat visits
// This improves performance metrics like LCP and FCP on subsequent visits
serviceWorkerRegistration.register({
  onSuccess: () => { /* Service worker registered */ },
  onUpdate: () => { /* New app version available */ },
});
